import { FC, useEffect, memo, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Select from 'shared-components/atom/select';
import WindowedSelect from 'react-windowed-select';
import {
  amazonLanguageCodeOptions,
  amazonSearchAdressesOptions,
  googleSearchRestrictedCountOptions,
  amazonSortbyOptions,
} from '../../constants';
import { useAutomationGlobalMethods } from '../../hooks';
import Input from 'shared-components/atom/input';
import { AutomationSettingsFactoryTypesProps } from '../../types';
import Alert from 'shared-components/atom/alert-message';
// import { cacheFunction } from 'helpers';
import './styles.scss';

const output = [
  '_keyword',
  '_amazon_type',
  '_amazon_rank_group',
  '_amazon_rank_absolute',
  '_amazon_xpath',
  '_amazon_image_url',
  '_amazon_domain',
  '_amazon_title',
  '_amazon_url',
  '_amazon_price_from',
  '_amazon_currency',
  '_amazon_data_asin',
  '_amazon_rating_type',
  '_amazon_rating_position',
  '_amazon_rating_rating_type',
  '_amazon_rating_value',
  '_amazon_rating_votes_count',
  '_amazon_rating_rating_max',
  '_is_amazon_choice',
  '_amazon_is_best_seller',
];

const AmazonScraperSettings: FC<AutomationSettingsFactoryTypesProps> = ({
  automationSendSettings,
  automationIndex,
  selectedRecipes,
  setAutomationSendSettings,
  setCompletedFields,
  id,
  isSettingsChange,
  setIsDirty,
  automationOutputTypes,
  automationInputTypes,
}) => {
  const [fieldList, setFieldList] = useState<any>([]);
  const [clicked, setClicked] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [selectedMaxSearchCount, setSelectedMaxSearchCount] = useState(googleSearchRestrictedCountOptions[0]);
  const [countryText, setCountryText] = useState({ label: 'United States', value: 2840 });
  const [fieldListWithTypes, setFieldListWithTypes] = useState([]);
  const [languageText, setLanguageText] = useState({
    label: 'English (United States)',
    value: 'en_US',
  });
  const [selectedSource, setSelectedSource] = useState<any>(null);
  const [saveFrom, setSaveFrom] = useState(1);
  const [saveTo, setSaveTo] = useState(100);
  const [errorMessage, setErrorMessage] = useState('');
  const [minPrice, setMinPrice] = useState<number | null>(null);
  const [maxPrice, setMaxPrice] = useState<number | null>(null);
  const [selectedLanguageCode, setSelectedLanguageCode] = useState<any>(null);
  const [selectedSortBy, setSelectedSortBy] = useState<any>({ label: 'featured', value: 'featured' });
  const zeroIndexOutput: string[] = automationIndex === 0 ? ['_amazon_keyword'] : [];

  const {
    liftingSettings,
    getDynamicAndIntegrationsSettings,
    getPreviousAutomationOutputOrPreviousRecipKeys,
    getPreviousAutomationOutputOrPreviousRecipKeysWithTypes,
    restoreSelectedSource,
  } = useAutomationGlobalMethods({
    automationSendSettings,
    setAutomationSendSettings,
    selectedRecipes,
    automationIndex,
    id,
  });

  const checkFields = () => {
    if (errorMessage || !selectedSortBy) {
      return false;
    }
    if (fieldList?.length === 0 ? !searchKeyword : Array.isArray(selectedSource) ? !selectedSource?.length : !selectedSource) return false;
    return true;
  };

  useEffect(() => {
    const { dynamic_settings } = getDynamicAndIntegrationsSettings();
    if (dynamic_settings) {
      const { keys } = dynamic_settings;

      const { settings } = keys[0];

      const depth = settings ? settings.depth : keys[0].depth;
      const inputValue = settings ? keys[0].inputValue : keys[0].keyword;
      const location_code = settings ? settings.location_code : keys[0].location_code;
      const save_from = settings ? settings.save_from : keys[0].save_from;
      const save_to = settings ? settings.save_to : keys[0].save_to;
      const sort_by = settings ? settings.sort_by : keys[0].sort_by;
      const price_min = settings ? settings.price_min : keys[0].price_min;
      const price_max = settings ? settings.price_max : keys[0].price_max;
      const language_code = settings ? settings.language_code : keys[0].language_code;

      setSearchKeyword(inputValue);
      const findedCount = googleSearchRestrictedCountOptions.find(item => item.value === depth);
      findedCount && setSelectedMaxSearchCount(findedCount);
      const findedCountry = amazonSearchAdressesOptions.find(item => item.value === location_code);
      const findedSortBy = amazonSortbyOptions.find(item => item.value === sort_by);
      const findedSelectedLangCode = amazonLanguageCodeOptions.find(item => item.value === language_code);

      findedCountry && setCountryText(findedCountry);
      findedSortBy && setSelectedSortBy(findedSortBy);
      // findedSelectedLangCode && setSelectedLanguageCode(findedSelectedLangCode);
      findedSelectedLangCode && setLanguageText(findedSelectedLangCode);
      //there may be zero here, since initially these fields were not
      setSaveFrom(save_from === undefined ? 1 : save_from);
      setSaveTo(save_to === undefined ? 100 : save_to);
      setMinPrice(price_min);
      setMaxPrice(price_max);
    }
  }, []);

  //recipe
  useEffect(() => {
    // if (fieldList.length > 0) return;
    if (automationIndex === 0) return;
    let options = getPreviousAutomationOutputOrPreviousRecipKeys();
    const optionsWithTypes = getPreviousAutomationOutputOrPreviousRecipKeysWithTypes();

    const { dynamic_settings } = getDynamicAndIntegrationsSettings();
    if (dynamic_settings) {
      const key = dynamic_settings.keys[0].key;
      restoreSelectedSource({ key: key, fieldList: options, setSelectedSource: setSelectedSource });
    }
    const filteredOptions =
      automationInputTypes && !automationInputTypes.includes('any')
        ? options.filter(
            (item: any) =>
              (optionsWithTypes &&
                optionsWithTypes[item.value] &&
                (automationInputTypes.includes(optionsWithTypes[item.value]) ||
                  optionsWithTypes[item.value] === 'any')) ||
              !(optionsWithTypes && optionsWithTypes[item.value]),
          )
        : [...options];

    setFieldList(filteredOptions);
    setFieldListWithTypes(optionsWithTypes);
    // setFieldList(options);
  }, [isSettingsChange]);

  useEffect(() => {
    if (fieldList?.length === 1) {
      setSelectedSource(fieldList[0]);
      setIsDirty();
      setClicked(true);
    }
  }, [fieldList]);

  useEffect(() => {
    // if (fieldList.length > 0) return;
    if (automationIndex === 0) return;
    let options = getPreviousAutomationOutputOrPreviousRecipKeys();
    const optionsWithTypes = getPreviousAutomationOutputOrPreviousRecipKeysWithTypes();
    const { dynamic_settings } = getDynamicAndIntegrationsSettings();

    const filteredOptions =
      automationInputTypes && !automationInputTypes.includes('any')
        ? options.filter(
            (item: any) =>
              (optionsWithTypes &&
                optionsWithTypes[item.value] &&
                (automationInputTypes.includes(optionsWithTypes[item.value]) ||
                  optionsWithTypes[item.value] === 'any')) ||
              !(optionsWithTypes && optionsWithTypes[item.value]),
          )
        : [...options];
    let changed = false;
    filteredOptions.map((item: any) => !fieldList.find((sub: any) => sub.value === item.value) && (changed = true));
    const update = filteredOptions.length !== fieldList.length || changed;
    if (filteredOptions.length === 0) {
      setSelectedSource(null);
      setClicked(true);
    }
    if (update) {
      const selOptionFound = filteredOptions.find((item: any) => dynamic_settings?.keys?.[0]?.key === item.value);
      setSelectedSource(!selOptionFound ? null : selOptionFound);
      setClicked(true);
      setFieldList(filteredOptions);
      setFieldListWithTypes(optionsWithTypes);
    }
  }, [automationSendSettings]);

  useEffect(() => {
    if (fieldList?.length) {
      if (clicked) return;
      const jsonParse = automationOutputTypes ? JSON.parse(automationOutputTypes) : {};
      liftingSettings({
        outputKeysData: [...fieldList.map((item: { value: any }) => item.value), ...zeroIndexOutput, ...output],
        outputKeysDataWithTypes: { ...fieldListWithTypes, ...jsonParse },
      });
    }
  }, [fieldList, fieldListWithTypes, automationOutputTypes]);

  // //memoize
  // const handleAmazonSearchAdressesOptions = (countryText: string) => {
  //   return amazonSearchAdressesOptions.find((item: { label: string; value: number }) => item.label === countryText);
  // };
  // const getMemoizeAmazonSearchAdressesOption = useRef(cacheFunction(handleAmazonSearchAdressesOptions));

  // const handleAmazonLanguageCodeOptions = (languageText: string) => {
  //   return amazonLanguageCodeOptions.find((item: { label: string; value: string }) => item.label === languageText);
  // };
  // const getMemoizeCryptoCurrencyToOption = useRef(cacheFunction(handleAmazonLanguageCodeOptions));

  useEffect(() => {
    if (!clicked) return;
    const isCompleted = checkFields();
    // setClicked(false);

    const hashId: any = new Date().getTime().toString();
    // const selectOption = getMemoizeAmazonSearchAdressesOption.current(countryText);
    // const selectLanguageOption = getMemoizeCryptoCurrencyToOption.current(languageText);
    if (!countryText || !languageText) {
      const message = !countryText ? 'Select country' : 'Select language';
      setCompletedFields({ index: automationIndex, checked: false, message });
    } else {
      setCompletedFields({ index: automationIndex, checked: isCompleted, message: isCompleted ? '' : errorMessage });
    }

    let localSettings = {
      keys: [
        {
          inputValue: fieldList.length === 0 && automationIndex === 0 ? searchKeyword.trim() : null,
          key: fieldList.length && selectedSource ? selectedSource.value : null,
          settings: {
            depth: selectedMaxSearchCount ? selectedMaxSearchCount.value : null,
            sort_by: selectedSortBy ? selectedSortBy.value : null,
            location_code: countryText ? countryText.value : null,
            save_from: saveFrom,
            save_to: saveTo,
            price_min: minPrice ? +minPrice : null,
            price_max: maxPrice ? +maxPrice : null,
            language_code: languageText ? languageText.value : null,
            uniqueHash: hashId,
          },
        },
      ],
    };
    const jsonParse = automationOutputTypes ? JSON.parse(automationOutputTypes) : {};
    liftingSettings({
      dynamicSettings: localSettings,
      outputKeysData: [...fieldList.map((item: { value: any }) => item.value), ...zeroIndexOutput, ...output],
      outputKeysDataWithTypes: { ...fieldListWithTypes, ...jsonParse },
    });
  }, [
    searchKeyword,
    selectedSource,
    selectedMaxSearchCount,
    countryText,
    saveTo,
    errorMessage,
    saveFrom,
    minPrice,
    maxPrice,
    // selectedLanguageCode,
    selectedSortBy,
    languageText,
  ]);

  const clearErrorMsg = () => {
    setTimeout(() => {
      setErrorMessage('');
    }, 3000);
  };

  const handleSaveFrom = (e: { target: { value: any } }) => {
    let val = e.target.value;
    if (isNaN(val)) {
      setErrorMessage('Please use only numbers');
      clearErrorMsg();
      return;
    }
    if (selectedMaxSearchCount.value <= +val) {
      setErrorMessage('"Save from" value can`t be greater than or equal to "Search result" value');
      clearErrorMsg();
      return;
    }
    if (saveTo <= +val) {
      setErrorMessage('Save from" value can`t be greater than or equal to "Save to result" value');
      clearErrorMsg();
      return;
    }
    setSaveFrom(+val);
    errorMessage && setErrorMessage('');
    !clicked && setClicked(true);
    setIsDirty();
  };

  const clearErrorTimeout = () => {
    setTimeout(() => {
      setErrorMessage('');
    }, 5000);
  };

  const handleSaveTo = (e: { target: { value: any } }) => {
    let val = e.target.value;
    if (isNaN(val)) {
      setErrorMessage('Please use only numbers');
      clearErrorMsg();
      return;
    }
    if (selectedMaxSearchCount.value < +val) {
      setErrorMessage('"Save to" value can`t be greater than "Search result" value');
      clearErrorMsg();
      return;
    }
    setSaveTo(+val);
    errorMessage && setErrorMessage('');
    !clicked && setClicked(true);
    setIsDirty();
  };

  return (
    <div className="google-automation-settings">
      <Row className="first-row">
        {fieldList.length > 0 || automationIndex > 0 ? (
          <Col lg={6} className="mb-4">
            <span className="label secondary-color required">Keyword</span>
            <Select
              options={fieldList}
              value={Array.isArray(selectedSource) ? selectedSource[0] : selectedSource}
              placeholder={'Select source'}
              onChange={(selectedItem: any) => {
                setSelectedSource(selectedItem);
                !clicked && setClicked(true);
                setIsDirty();
              }}
            />
          </Col>
        ) : (
          <Col lg={6} className="mb-4">
            <span className="label secondary-color required">Keyword</span>
            <Input
              value={searchKeyword}
              onChange={e => {
                setSearchKeyword(e.target.value);
                !clicked && setClicked(true);
                setIsDirty();
              }}
            />
          </Col>
        )}
        <Col xl={6} className="search-fields">
          <Row>
            <Col lg={4} xl={4} className="mb-4">
              <span className="label secondary-color required">Search results</span>
              <Select
                fullWidth
                options={googleSearchRestrictedCountOptions}
                value={selectedMaxSearchCount}
                placeholder={'Select column'}
                onChange={(selectedItem: any) => {
                  setSelectedMaxSearchCount(selectedItem);
                  setSaveFrom(1);
                  setSaveTo(selectedItem.value);
                  !clicked && setClicked(true);
                  setIsDirty();
                }}
              />
            </Col>
            <Col lg={4} xl={4} className="mb-4 results-from-to">
              <h5 className="pointer-title">From</h5>
              <div>
                <span className="label secondary-color save-result required" style={{ whiteSpace: 'nowrap' }}>
                  Save results
                </span>
                <Input value={saveFrom} onChange={handleSaveFrom} />
              </div>
            </Col>
            <Col lg={4} xl={4} className="mb-4 results-from-to">
              <h5 className="pointer-title">To</h5>
              <div>
                <span className="label secondary-color" style={{ visibility: 'hidden' }}>
                  to
                </span>
                <Input value={saveTo} onChange={handleSaveTo} />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col lg={6} className="mb-4">
          <span className="label secondary-color required">Language</span>
          <WindowedSelect
            options={amazonLanguageCodeOptions}
            onChange={(selectedOption: any) => {
              if (selectedOption && languageText && selectedOption.value === languageText.value) return;
              setLanguageText(selectedOption);
              !clicked && setClicked(true);
              setIsDirty();
            }}
            value={languageText}
          />
        </Col>
        <Col lg={6} className="mb-4">
          <span className="label secondary-color required">Country</span>
          <WindowedSelect
            options={amazonSearchAdressesOptions}
            onChange={(selectedOption: any) => {
              if (selectedOption && countryText && selectedOption.value === countryText.value) return;
              setCountryText(selectedOption);
              !clicked && setClicked(true);
              setIsDirty();
            }}
            value={countryText}
          />
        </Col>
      </Row>
      <Row>
        <Col lg={6} className="mb-4">
          <span className="label secondary-color">Sort by</span>
          <Select
            options={amazonSortbyOptions}
            value={selectedSortBy}
            placeholder={'Select source'}
            onChange={(selectedItem: any) => {
              setSelectedSortBy(selectedItem);
              !clicked && setClicked(true);
              setIsDirty();
            }}
          />
        </Col>
        <Col lg={3} className="mb-4">
          <span className="label secondary-color">Min price</span>
          <Input
            value={minPrice || ''}
            onChange={e => {
              let val = e.target.value;
              if (isNaN(val)) {
                setErrorMessage('min price must be number');
                clearErrorTimeout();
                return;
              }
              if (maxPrice && +val > +maxPrice) {
                setErrorMessage('min price must be less than max price');
                clearErrorTimeout();
                return;
              }
              errorMessage && setErrorMessage('');
              setMinPrice(e.target.value);
              !clicked && setClicked(true);
              setIsDirty();
            }}
          />
        </Col>
        <Col lg={3} className="mb-4">
          <span className="label secondary-color">Max price</span>
          <Input
            value={maxPrice || ''}
            onChange={e => {
              let val = e.target.value;
              if (isNaN(val)) {
                setErrorMessage('max price must be number');
                clearErrorTimeout();
                return;
              }
              if (minPrice && +val < +minPrice) {
                setErrorMessage('max price must be greater than min price');
              } else {
                errorMessage && setErrorMessage('');
              }
              setMaxPrice(e.target.value);
              !clicked && setClicked(true);
              setIsDirty();
            }}
          />
        </Col>
      </Row>
      {errorMessage && (
        <Row className="mb-4">
          <Col md={12}>
            <Alert type="error" className="create-workflow">
              {errorMessage}
            </Alert>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default memo(AmazonScraperSettings);
